
import { Global, LineSelectedMemo } from '../../model';
export class NewValuesFormsTasksMemosSave {
  static set(newVal = {}, selectedMemo: LineSelectedMemo){
    let index:number = selectedMemo.scheduledIndex();
    let memoData = Global.getTasksMemoData(selectedMemo.composite_id())
    let memoValue = ''
    if(memoData){
      memoValue = memoData.value
    }
    newVal['forms_tasks_memos_save'] = {
      inputs: {
        index: {
          value: index
        },
        task_id: {
          value: selectedMemo.taskId()
        },
        value: {
          value: memoValue
        }
      }
    }
  }
}
